import { useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';

import { Wrap, Trigger, Menu, Item } from './format-select.v2.styled';

const CaretIcon = () => (
  <svg className="caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden>
    <path d="M6 9l6 6 6-6" />
  </svg>
);

/**
 * Compact export-format dropdown for the v2 redesign — a pill (current format
 * + caret) that opens a menu of formats. Modelled on the language selector.
 */
export const FormatSelectV2 = ({ value, options, onChange }) => {
  const [open, setOpen] = useState(false);

  const pick = (format) => {
    onChange(format);
    setOpen(false);
  };

  return (
    <OutsideClickHandler onOutsideClick={() => setOpen(false)}>
      <Wrap>
        <Trigger type="button" aria-expanded={open} aria-label="Формат выгрузки" onClick={() => setOpen((v) => !v)}>
          {value.toUpperCase()}
          <CaretIcon />
        </Trigger>
        {open && (
          <Menu role="listbox">
            {options.map((format) => (
              <Item key={format} type="button" role="option" aria-selected={format === value} $active={format === value} onClick={() => pick(format)}>
                {format.toUpperCase()}
              </Item>
            ))}
          </Menu>
        )}
      </Wrap>
    </OutsideClickHandler>
  );
};
